module.exports = __webpack_public_path__ + "img/close-grey.71ac956a.svg";